import * as React from "react";
import {Combos, Permutator} from "./utils"
import InputForm from "./InputForm"

export default function App() {
  const [alphabetize, updateAlpha] = React.useState(true);
  const [modifiers, update] = React.useState([
    ["cast iron"],
    ["floor"],
    ["vent", "register"],
    ["4x10", "4x12"]
  ]);

  const combos = React.useMemo(() => {
    return Combos(modifiers)
  }, [modifiers]);

  const keywords = React.useMemo(() => {
    let temp = {}
    combos.forEach((combination, index1) => {
      Permutator(combination).forEach((c1) => {
        temp[c1.join(" ")] = 1;
      });
    });
    if (alphabetize) {
      return Object.keys(temp).sort();
    } else {
      return Object.keys(temp);
    }
  },[combos, alphabetize])

  return (
    <>
    <div className="text-center alert-info">
      <a className="badge bg-dark" href="/">Home</a>
    </div>
    <div className="container">
      <div className="text-center">
        <h1>{document.title}</h1>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-3">
            <p className="lead">Keyword List: </p>
            <div className="form-group">
              <input classNam="form-control" id="alpha" type="checkbox" checked={alphabetize} onChange={() => updateAlpha(!alphabetize)} />
              {' '}
              <label htmlFor="alpha">Alphabetize keywords</label>
            </div>
            <RenderResult list={keywords} />
          </div>
          <div className="col-sm-5">
            <p className="lead">About:</p>
            <p className="lead">
            Sometimes you want to build a giant list of all possible keyword permutations for a set of words.
            <br/>
            This Tool lets you add keywords and synonyms for each word, and then builds a complete list of all permutations.
            </p>
          </div>

          <div className="col-sm-4">
            <p className="lead">Modifiers:</p>
            <InputForm modifiers={modifiers} update={update} />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}


function RenderResult({ list }) {
  return (
    <>
      <textarea
        rows={list.length}
        className="form-control"
        readOnly={true}
        value={list.join("\n")}
        onClick={(e) => e.target.select()}
      />
    </>
  );
}
